export default __webpack_public_path__ + "static/media/gg.8fa30c93.png";